import { Copy, ExternalLink, Link2 } from 'lucide-react'
import { toast } from 'sonner'
import type { Proposta } from '@/types'
import { formatCurrency } from '@/utils/format-currency'
import { resolveProposalPublicLink } from './proposalPublicLink'

type ProposalPublicLinkCardProps = {
  proposal: Proposta
}

export function ProposalPublicLinkCard({ proposal }: ProposalPublicLinkCardProps) {
  const link = resolveProposalPublicLink(proposal)

  const handleOpen = () => {
    window.open(link, '_blank', 'noopener,noreferrer')
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link)
      toast.success('Link da proposta copiado!')
    } catch {
      toast.error('Não foi possível copiar o link')
    }
  }

  return (
    <div className="glass-card p-4 space-y-3 border border-accent/20 bg-accent/[0.04]">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-2">
            <Link2 size={14} />
            Link público da proposta
          </h3>
          <p className="text-[11px] text-text-muted mt-1 leading-snug">
            Envie este link ao cliente para visualizar a proposta de{' '}
            <strong className="text-text-primary">{formatCurrency(proposal.totalFinal)}</strong>.
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 p-2.5 rounded-lg bg-white/[0.04] border border-white/[0.08]">
        <code className="flex-1 text-[11px] text-text-primary break-all leading-relaxed">{link}</code>
        <button
          type="button"
          onClick={() => void handleCopy()}
          className="p-1.5 rounded-md text-text-muted hover:text-accent hover:bg-accent/10 transition-colors shrink-0"
          title="Copiar link"
        >
          <Copy size={14} />
        </button>
        <button
          type="button"
          onClick={handleOpen}
          className="p-1.5 rounded-md text-text-muted hover:text-accent hover:bg-accent/10 transition-colors shrink-0"
          title="Abrir em nova aba"
        >
          <ExternalLink size={14} />
        </button>
      </div>
    </div>
  )
}
